module.exports = __webpack_public_path__ + "static/img/contact_logo8_h.65bd39b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo8_h.png
// module id = M2tT
// module chunks = 1